import React from 'react';
import { connect } from 'react-redux';

import {
  Element,
  Typography,
  FontType,
  Color
} from '@americanexpress/aqx-components';

import { getOfferBadgeText, getIsTier1Card, getIsTier2Offer } from '../redux';
import { isPznDataLoaded } from 'src/universal/redux/pznData';

const Tier1Badge = ({
  badgeText = '',
  styles,
  isTier1Card,
  isTier2Offer,
  defaultOfferText,
  isHeader,
  pznDataLoaded
}) => {
  const shouldRenderBadge =
    pznDataLoaded &&
    ((isTier1Card && isHeader) || (!isTier1Card && isTier2Offer && !isHeader));
  const formattedBadgeText = isTier2Offer ? badgeText : defaultOfferText;

  return shouldRenderBadge ? (
    <div className={styles.badgeWrapper}>
      <Element className={styles.offerBadge}>
        <Typography
          $size={12}
          $family={FontType.HelveticaBold}
          className={styles.offerBadgeText}
          theme={{
            color: Color.White
          }}
        >
          {formattedBadgeText}
        </Typography>
      </Element>
    </div>
  ) : (
    <div />
  );
};

const mapStateToProps = (state, { shortName }) => {
  return {
    isTier1Card: getIsTier1Card(state, shortName),
    isTier2Offer: getIsTier2Offer(state, shortName),
    badgeText: getOfferBadgeText(state, shortName),
    pznDataLoaded: isPznDataLoaded(state)
  };
};

export default connect(mapStateToProps)(Tier1Badge);
